"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackingScope = exports.configureTracking = exports.trackingScopeApi = exports.TrackingScopeApi = void 0;
var DEFAULT_CONFIG = {
    required: false,
    default: '',
};
var TrackingScopeApi = /** @class */ (function () {
    function TrackingScopeApi() {
        this._trackingScopeParams = new Map();
    }
    TrackingScopeApi.prototype.add = function (key, config) {
        this._trackingScopeParams.set(key, __assign(__assign({}, DEFAULT_CONFIG), config));
        return this;
    };
    TrackingScopeApi.prototype.get = function (keys) {
        var _this = this;
        if (!keys) {
            keys = Array.from(this._trackingScopeParams.keys());
        }
        if (!Array.isArray(keys)) {
            keys = [keys];
        }
        return keys.reduce(function (prev, cur) {
            var _a;
            var config = _this._trackingScopeParams.get(cur);
            var value = config ? config.value || config.default : undefined;
            if (!value && config && config.required) {
                throw new Error("Tracking Scope param `" + cur + "` is required.");
            }
            return __assign(__assign({}, prev), (_a = {}, _a[cur] = value, _a));
        }, {});
    };
    TrackingScopeApi.prototype.set = function (definitions) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(definitions)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (typeof value !== 'string') {
                    throw new Error("Tracking scope param `" + key + "` must be a string.");
                }
                var config = this._trackingScopeParams.get(key);
                // If the params hasn't been added or the value is falsy when required
                // bail out of setting it.
                if (!config)
                    continue;
                if (config.required && !config.default && !value) {
                    throw new Error("Tracking scope param `" + key + "` is required.");
                }
                this._trackingScopeParams.set(key, __assign(__assign({}, config), { value: value }));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this;
    };
    return TrackingScopeApi;
}());
exports.TrackingScopeApi = TrackingScopeApi;
// Setup our global scope values
exports.trackingScopeApi = new TrackingScopeApi();
exports.trackingScopeApi
    .add('service', { required: true })
    .add('release', {
    required: true,
    default: '<unknown>',
})
    .add('baseUrl', { required: false });
exports.configureTracking = function (definitions) {
    exports.trackingScopeApi.set(definitions);
};
exports.getTrackingScope = function (keys) { return exports.trackingScopeApi.get(keys); };
